module.exports = class Constraints {
    constructor() {
        /** @type {Boolean} */  this.IsDisneyEulaRequired = null;
        /** @type {Number} */   this.WatchExpirationHours = null;
    }
};
